import PCNativeBridge from 'UTILS/nativeBridge'; // 加载PC交互
import { envData, envConf } from 'ENV';
import { getQueryString } from 'UTILS/utils';
import { curScheme } from 'CONFIG/config';

let { ENV } = envData;
let env = ENV === 'prod' ? '' : 'beta/';

let fromHost = getQueryString('host') || (ENV === 'prod' ? envConf['prodFWeb'] : envConf['betaFWeb']);
/**
 * 客户端通信交互
 * Version 1.1
 */
(function (window) {
  // 避免多次初始化, 多次初始化才能保证刷新最新
  //  if (window.WebViewJSBridge) return;
  //  window.WebViewJSBridge = {};

  // todo,SIGN,统一更改为curScheme，2022.08.12
  var browser = {
    versions: (function () {
      var u = navigator.userAgent,
        caramel = /(caramel|oxygen)/i.test(u),
        blacksuger = u.indexOf('blacksuger') != -1,
        blacksugerWeb = /YES_PC/i.test(u) || top !== self || window.isPostMsg, // 内嵌iframe需要判断flutter web
        zhuazhua = u.toLocaleLowerCase().indexOf('zhuazhua') != -1,
        oxygen = /(oxygen|caramel)/i.test(u),
        pomelo = u.toLocaleLowerCase().indexOf('pomelo') != -1,
        miya = u.toLocaleLowerCase().indexOf('miya') != -1,
        mizhua = u.toLocaleLowerCase().indexOf('mizhua') != -1,
        chikii = u.toLocaleLowerCase().indexOf('chikii') != -1,
        caiji = u.toLocaleLowerCase().indexOf('caiji') != -1,
        miko = u.toLocaleLowerCase().indexOf('gamecomm') != -1,
        yesdesk = u.toLocaleLowerCase().indexOf('yesdesk') != -1, // TODO
        fish = u.toLocaleLowerCase().indexOf('fish') != -1,
        oxygenstarry = u.toLocaleLowerCase().indexOf('oxygenstarry') != -1,
        oxygentime = u.toLocaleLowerCase().indexOf('oxygentime') != -1,
        hydrogen = u.toLocaleLowerCase().indexOf('hydrogen') != -1,
        yoyo = u.toLocaleLowerCase().indexOf('yoyo') != -1,
        callme = u.toLocaleLowerCase().indexOf('callme') != -1,
        zygoteWindows = u.toLocaleLowerCase().indexOf('zygote_windows') != -1;

      return {
        inApp:
          zygoteWindows ||
          caramel ||
          yoyo ||
          blacksuger ||
          blacksugerWeb ||
          oxygen ||
          zhuazhua ||
          pomelo ||
          miya ||
          mizhua ||
          chikii ||
          caiji ||
          miko ||
          hydrogen ||
          callme ||
          yesdesk ||
          fish ||
          oxygenstarry ||
          oxygentime
            ? 1
            : 0,
        isBlacksugerWeb: blacksugerWeb, // flutter web
        isFlutter: blacksuger || blacksugerWeb || miko || hydrogen || yoyo || yesdesk || fish || oxygenstarry || oxygentime ? true : false, // 判断是否是flutter框架
        isFlutterWindow: zygoteWindows ? true : false,
        PCMiz: /PCMiz/i.test(u), // mizPc
        PCHydrogen: /hydrogenPc/i.test(u), // hydrogenPc

        isLocal: /(localhost|10\.|0\.0|192\.168)/.test(location.origin),
        trident: u.indexOf('Trident') > -1, //IE
        presto: u.indexOf('Presto') > -1, //opera
        webKit: u.indexOf('AppleWebKit') > -1, //apple&google kernel
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //firfox
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //is Mobile
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i) || !!u.match(/\(Maci[^;]+; .+Mac OS X/i), //is ios
        android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android
        iPhone: u.indexOf('iPhone') > -1, //iPhone or QQHD
        iPad: u.indexOf('iPad') > -1, //iPad
        iPod: u.indexOf('iPod') > -1, //iPod
        webApp: u.indexOf('Safari') == -1, //is webapp,no header and footer
        weixin: u.indexOf('MicroMessenger') > -1, //is wechat
        qq: u.match(/\sQQ/i) == ' qq', //is qq
      };
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase(),
  };
  const IS_PC_CLIENT = browser.versions.PCMiz || browser.versions.PCHydrogen;

  if (browser.versions.isBlacksugerWeb) {
    // 用于flutter web监听数据
    window.addEventListener('message', function (event) {
      console.log('web收到回调', event.data);
      var data = {};

      if (Object.prototype.toString.call(event.data) === '[object String]') {
        try {
          data = JSON.parse(event.data);
        } catch (e) {
          data = event.data;
        }
      } else {
        data = event.data;
      }

      if (data.callbackId) {
        ApiBridge.onCallback(Number(data.callbackId), data);
      }

      if (data.funcName) {
        if (typeof window[data.funcName] === 'function') {
          window[data.funcName](data.data);
        }
      }
    });
  }

  var global = this || window;
  var ApiBridge = {
    msgQueue: [],
    callbackCache: [],
    callbackId: 0,
    processingMsg: false,
    isReady: false,
    isNotifyReady: false,
  };

  ApiBridge.create = function () {
    ApiBridge.bridgeIframe = document.createElement('iframe');
    ApiBridge.bridgeIframe.style.display = 'none';
    document.documentElement.appendChild(ApiBridge.bridgeIframe);
  };

  ApiBridge.prepareProcessingMessages = function () {
    ApiBridge.processingMsg = true;
  };

  ApiBridge.fetchMessages = function () {
    if (ApiBridge.msgQueue.length > 0) {
      var messages = JSON.stringify(ApiBridge.msgQueue);
      ApiBridge.msgQueue.length = 0;
      return messages;
    }
    ApiBridge.processingMsg = false;
    return null;
  };

  ApiBridge.callNative = function (clz, method, args, callback) {
    var msgJson = {};
    msgJson.clz = clz;
    msgJson.method = method;
    if (args != undefined) msgJson.args = args;

    // 如果是PC，则不处理
    if (browser.versions.PCMiz || browser.versions.PCHydrogen || !browser.versions.inApp) {
      return;
    }

    if (callback) {
      var callbackId = ApiBridge.getCallbackId();
      ApiBridge.callbackCache[callbackId] = callback;
      if (msgJson.args) {
        msgJson.args.callbackId = callbackId.toString();
      } else {
        msgJson.args = {
          callbackId: callbackId.toString(),
        };
      }
    }
    // 判断是否在APP里面，或者是强制APP
    if (browser.versions.inApp || window.isInApp) {
      // alert(navigator.userAgent)
      // alert(browser.versions.isFlutter)
      // 如果是flutter框架
      //因为flutter给webview赋值ua的时机有可能比上面broswer执行的时机晚，所以下面必须直接判断，不能用browser.versions.isFlutter
      const uaLowerCase = navigator.userAgent.toLocaleLowerCase();
      const isFlutter = /(hydrogen|yoyo|fish|oxygenstarry|oxygentime)/i.test(uaLowerCase);
     
      // window flutter 通信
      if(browser.versions.isFlutterWindow) {
        if(window.chrome && window.chrome.webview){
          window.chrome.webview.postMessage(JSON.stringify(msgJson));
        } else {
          console.log('找不到window.chrome.webview');
        }
      }
      // app flutter 通信
      else if (isFlutter) {
        //  console.log(msgJson);
        if (window.jsBridgeChannelApi) {
          // jsBridgeChannel 是由Flutter框架注册的方法
          // 非windows原生方法
          window.jsBridgeChannelApi.postMessage(JSON.stringify(msgJson));
        }
        // 由于flutter web无法判断，默认都执行postMessage处理
        else if (fromHost) {
          // web 通过postMessage跨域
          if (top !== self) {
            // 如果同域可以获取得父级域名
            try {
              var parentLocation = window.parent.location;
              var parentHost = parentLocation.protocol + '//' + parentLocation.host;

              fromHost = parentHost;
            } catch (err) {}

            try {
              console.log('postMessage', JSON.stringify(msgJson), fromHost);
              window.parent.postMessage(JSON.stringify(msgJson), decodeURIComponent(fromHost));
            } catch (err) {
              console.error(err);
            }
          } else {
            console.log('postMessage', JSON.stringify(msgJson), fromHost);
            window.postMessage(JSON.stringify(msgJson), decodeURIComponent(fromHost));
          }
        }
        return;
      }

      if (browser.versions.ios) {
        if (ApiBridge.bridgeIframe == undefined) {
          ApiBridge.create();
        }
        // var msgJson = {"clz": clz, "method": method, "args": args};
        ApiBridge.msgQueue.push(msgJson);
        if (!ApiBridge.processingMsg) ApiBridge.bridgeIframe.src = 'kcnative://go';
      } else if (browser.versions.android) {
        // android
        prompt(JSON.stringify(msgJson));
      }
    }
  };

  ApiBridge.log = function (msg) {
    ApiBridge.callNative('ApiBridge', 'JSLog', {
      msg: msg,
    });
  };

  ApiBridge.getCallbackId = function () {
    return ApiBridge.callbackId++;
  };

  ApiBridge.onCallback = function (callbackId, obj) {
    if (ApiBridge.callbackCache[callbackId]) {
      ApiBridge.callbackCache[callbackId](obj);
      // ApiBridge.callbackCache[callbackId] = undefined;
      // //如果是注册事件的话，不能undefined；
    }
  };

  ApiBridge.onBridgeInitComplete = function (callback) {
    ApiBridge.callNative('ApiBridge', 'onBridgeInitComplete', {}, callback);
  };

  ApiBridge.onNativeInitComplete = function (callback) {
    ApiBridge.isReady = true;
    console.log('--- kerkee onNativeInitComplete end ---');

    if (callback) {
      callback();
      ApiBridge.isNotifyReady = true;
      console.log('--- device ready go--- ');
    }
  };

  ApiBridge.compile = function (aIdentity, aJS) {
    var value;
    var error;
    try {
      value = eval(aJS);
    } catch (e) {
      // error = "name: " + e.name +"; errorNumber: " + (e.number & 0xFFFF ) + "; message: " + e.message;
      var err = {};
      err.name = e.name;
      err.message = e.message;
      err.number = e.number & 0xffff;
      error = err;
    }

    ApiBridge.callNative('ApiBridge', 'compile', {
      identity: aIdentity,
      returnValue: value,
      error: error,
    });
  };

  var _Configs = {
    isOpenJSLog: false,
    sysLog: {},
    isOpenNativeXHR: true,
    sysXHR: {},
  };
  _Configs.sysLog = global.console.log;
  _Configs.sysXHR = global.XMLHttpRequest;

  // js通信交互方法
  var kerkee = {};

  /*****************************************
   * 事件监听
   *****************************************/
  kerkee.Event = {};
  // kerkee.Event.LOADED = "loaded";
  // kerkee.Event.LOAD_ERROR = "load_error";
  // kerkee.Event.LOAD_PROGRESS = "load_progress";
  kerkee.addEventListener = function (event, callback) {
    ApiBridge.callNative(
      'event',
      'addEventListener',
      {
        event: event,
      },
      callback
    );
  };

  /* Scroll to the bottom of the page when the callback function and the threshold setting */
  //callback:Return to the page in webview upper vertex Y value
  kerkee.registerHitPageBottomListener = function (callback, threshold) {
    ApiBridge.callNative('ApiBridge', 'setHitPageBottomThreshold', {
      threshold: threshold,
    });
    kerkee.onHitPageBottom = callback;
  };

  /**
   * 获取剪切板内容，【不确定】
   * @params { String }, texts, 内容
   * @params { Function } callback, 回调
   */
  kerkee.getClipboardData = function (texts, callback) {
    ApiBridge.callNative(
      'jsBridgeClient',
      'getClipboardData',
      {
        'text ': texts,
      },
      callback
    );
    ApiBridge.callNative(
      'jsBridgeClient',
      'oxygen__getClipboardData',
      {
        'text ': texts,
      },
      callback
    );
  };
  /**
   * 注册页面滚动监听【不确定】
   * @params { Function } callback, 滚动回调
   */
  kerkee.registerScrollListener = function (callback) {
    ApiBridge.callNative('ApiBridge', 'setPageScroll', {
      isScrollOn: true,
    });
    kerkee.onPageScroll = callback;
  };

  /**
   * 接口通用传参回调中转
   * @params { string|Object } clz, 参数对象{ clz: <string|桥接名称|jsBridgeClient,event,ApiBridge>, method: <string|方法名称>, args: <object|参数对象>, callback: <function|回调方法> }
   * @params { string } method
   * @params { Object } args, 参数对象, 默认为{}
   * @params { function } callback 回调方法
   */
  ApiBridge.invoke = function (clz, method, args, callback) {
    if (Object.prototype.toString.call(clz) === '[object Object]') {
      method = clz.method;
      args = clz.args || {};
      callback = clz.callback || null;
      clz = clz.clz || 'jsBridgeClient';
    } else {
      clz = clz || 'jsBridgeClient';
      args = args || {};
    }

    if (callback) {
      ApiBridge.callNative(clz, method, args, callback);
      return;
    }

    ApiBridge.callNative(clz, method, args);
    return;
  };

  /**
   * 设备已准备完成
   */
  kerkee.onDeviceReady = function (handler) {
    ApiBridge.onDeviceReady = handler;

    if (ApiBridge.isReady && !ApiBridge.isNotifyReady && handler) {
      console.log('-- device ready --');
      handler();
      ApiBridge.isNotifyReady = true;
    }
  };

  /*****************************************
   * 接口
   *****************************************/
  /**
   * 获取客户端用户token
   * 回调的数据结构：
   *{
   *  int32 charmLevel = 1;
   *  string clanName = 2;
   *  int64 gold = 3;
   *  string icon = 4;
   *  int32 id = 5;
   *  int32 id2 = 6;
   *  string key = 7;
   *  int32 language = 8;
   *  string name = 9;
   *  int32 roomId = 10;
   *  int32 sex = 11;
   *  string shortlink_host = 12;
   *  int32 targetId = 13;
   *  int64 tokenCreateTime = 14;
   *  string tokenId = 15;
   *  string version = 16;
   *  int32 wealthLevel = 17;
   *  int32 webviewInitTime = 18;
   *}
   * @params { Function }, callback 回调
   * @return { Object } ,  { key, player }
   *
   */
  kerkee.initData = function (callback) {
    if (IS_PC_CLIENT) {
      PCNativeBridge.getLoginInfo().then((res) => {
        callback &&
          callback({
            key: res.token,
            player: res.profile,
          });
      });
    } else {
      ApiBridge.callNative('jsBridgeClient', 'initData', {}, callback);
    }
  };

  /**
   * 获取appid登录的token(目前主要用于注销token)
   * @params { Function }, callback 回调
   * @return { Object } ,  { key, player }
   *
   */
  kerkee.appleLoginToken = function (callback) {
    ApiBridge.callNative('jsBridgeClient', 'appleLoginToken', {}, callback);
  };

  /**
   * 用户私聊
   * @params { Number } id, 用户id
   * params:{
   *  id: Number,
   *  name:String,
   * message:String,
   * }
   */
  kerkee.sendIMMessage = function (params) {
    if (IS_PC_CLIENT) {
      PCNativeBridge.openIMMessageWindow(params.id, params.message);
      return;
    }
    ApiBridge.callNative('jsBridgeClient', 'sendIMMessage', params);
  };
  /**
   * 获取设备 id
   * @params { Function } callback，回调
   */
  kerkee.getDeviceID = function (callback) {
    ApiBridge.callNative('jsBridgeClient', 'getDeviceID', {}, callback);
    ApiBridge.callNative('jsBridgeClient', 'oxygen__getDeviceID', {}, callback);
  };

  /**
   * 打开手机的通知权限（支持：yes）
   * @params { Function } callback，回调
   */
  kerkee.openNotificationPage = function (callback) {
    ApiBridge.callNative('jsBridgeClient', 'openNotificationPage', {}, callback);
  };

  /**
   * 前往AppStore更新【不确定】
   * @params { String }, url appstore地址
   */
  kerkee.gotoUpdate = function (url) {
    ApiBridge.callNative('jsBridgeClient', 'gotoUpdate', {
      url: url,
    });
    ApiBridge.callNative('jsBridgeClient', 'oxygen__gotoUpdate', {
      url: url,
    });
  };

  // 测试
  kerkee.testJSBrige = function (aString) {
    ApiBridge.callNative('jsBridgeClient', 'testJSBrige', {
      info: aString,
    });
  };
  // 关闭键盘
  kerkee.closeKeyboard = function () {
    ApiBridge.callNative('jsBridgeClient', 'closeKeyboard');
  };
  // 获取菜鸡Token
  kerkee.initPcGoData = function (callback) {
    ApiBridge.callNative('jsBridgeClient', 'initPcGoData', {}, (param) => {
      callback(param);
    });
  };
  // 视频发送
  kerkee.getVideoUrl = function (callback) {
    ApiBridge.callNative('jsBridgeClient', 'getVideoUrl', {}, (param) => {
      callback(param);
    });
  };
  // 视频发送
  kerkee.sendKeFuVideoCallBack = function (data) {
    ApiBridge.callNative('jsBridgeClient', 'sendKeFuVideoCallBack', data);
  };
  /**
   * 购买宝石，【不确定】
   * @params { Number }, giftId, 宝石id
   * @params { Nubmer }, giftNum, 宝石数量
   */
  kerkee.buyBijou = function (giftId, giftNum) {
    ApiBridge.callNative('jsBridgeClient', 'buyBijou', {
      giftId: giftId,
      giftNum: giftNum,
    });
    ApiBridge.callNative('jsBridgeClient', 'oxygen__buyBijou', {
      giftId: giftId,
      giftNum: giftNum,
    });
  };

  /**
   * 这个不是关闭窗口，关闭窗口是finishWebView，这个会使整个跳转hash的失效
   */
  kerkee.closeWindow = function () {
    ApiBridge.callNative('jsBridgeClient', 'closeWindow');
  };

  /**
   * 是不是直接返回到应用，浏览器的history将失效(焦糖>=4.7.0)
   * @param { Boolean } flag, true: 直接返回应用，false：正常返回，默认false
   */
  kerkee.backToAppFlag = function (flag) {
    flag = typeof flag === 'undefined' ? false : flag;
    ApiBridge.callNative('jsBridgeClient', 'backToAppFlag', {
      backToAppFlag: flag,
    });
  };

  //清除历史记录 目前仅氧气在用
  kerkee.clearHistory = function () {
    ApiBridge.callNative('jsBridgeClient', 'clearHistory', {});
  };

  /**
   * 关闭webView
   */
  kerkee.finishWebView = function (halfwebview) {
    if (IS_PC_CLIENT) {
      PCNativeBridge.closePopupPage()
    } else {
      //halfwebview 兼容ios，解决ios调用该方法会退房的bug
      ApiBridge.callNative('jsBridgeClient', 'finishWebView', {
        halfwebview: halfwebview,
      });
    }
  };

  /**
   * 关闭H5并且跳转路由/链接
   * @params { Object } halfwebview和routerUrl, 是否半屏和跳转路由
   */
  kerkee.finishWebAndJumpRoute = function (data) {
    ApiBridge.callNative('jsBridgeClient', 'finishWebAndJumpRoute', {
      routerUrl: data.routerUrl,
      halfwebview: data.halfwebview,
    });
  };

  /**
   * 隐藏导航栏。可用于网页全屏展示
   */
  kerkee.webNavigitionHidden = function (ishidden = true, statusBarTextTransparent = true) {
    ApiBridge.callNative('jsBridgeClient', 'webNavigitionHidden', {
      ishidden,
      statusBarTextTransparent,
    });
  };
  /**
   * 切换页面顶部的状态栏的颜色（islightcolor = true为白色，= false为黑色）
   */
  kerkee.webStatusBarColor = function (islightcolor = true) {
    ApiBridge.callNative('jsBridgeClient', 'webStatusBarColor', {
      islightcolor,
    });
  };
  /**
   * 设置页面顶部的状态栏的背景色
   */
  kerkee.webStatusBarBgColorStr = function (statusBarBgColorStr) {
    if (!statusBarBgColorStr) return console.error('请传入色值');
    ApiBridge.callNative('jsBridgeClient', 'webStatusBarBgColorStr', {
      statusBarBgColorStr,
    });
  };
  /**
   * 获取页面顶部的状态栏的高度（用于兼容刘海屏）
   */
  kerkee.webStatusBarHeight = function (callback) {
    ApiBridge.callNative('jsBridgeClient', 'webStatusBarHeight', {}, (param) => {
      console.log('webStatusBarHeight', param);
      return typeof param === 'object' ? callback(param.statusbarheight) : callback(+param);
    });
  };

  /**
   * 分享链接 【不确定】
   * @params { Boolean }, isShare, true: 分享别的链接，false:分享当前链接
   * @params { String }, title, 标题
   * @returns { Function } 页面被触发的全局函数window.shareClick()
   *
   */
  kerkee.shareURL = function (isShare, title) {
    ApiBridge.callNative('jsBridgeClient', 'shareURL', {
      isShare: isShare,
      title: title,
    });
    ApiBridge.callNative('jsBridgeClient', 'oxygen__shareURL', {
      isShare: isShare,
      title: title,
    });
  };

  /**
   * 通用分享
   * @params { Number } type, 0全平台，1微信
   * @params { Number } sharetype, 0图片，1网址
   * @params { String } title, 标题
   * @params { String } content, 副标题内容
   * @params { String } url, 分享链接
   * @params { String } thumb, 缩略图
   * @params { String } sharetitle, 页面标题
   * @params { Array<Number> } platform, 分享平台(yes可用), [1, 4, 7, <...>]
   *
   * @returns { Function } window.clickShareIcon, 返回type类型
   * 焦糖：返回type类型 0:微信好友分享 1:微信朋友圈分享 2:复制链接分享 3:facebook分享动态 4:QQ分享 5:QQ空间分享 6:新浪微博分享
   * yes：返回type类型 0-微信好友 1-微信朋友圈 2-复制链接 3-Facebook 4-QQ 5-QQ空间 6-新浪微博 7-保存图片 8-YES好友 9-口令
   */
  kerkee.share = function (type, sharetype, title, content, url, thumb, sharetitle, platform) {
    if (IS_PC_CLIENT) {
      if (document.execCommand) {
        let tmpInput = document.getElementById('tmpShareInput');

        if (!tmpInput) {
          tmpInput = document.createElement('input');
          tmpInput.id = 'tmpShareInput';
          tmpInput.setAttribute('type', 'text');
          tmpInput.style.cssText = ['position:absolute', 'left: -100%', 'top: -100%'].join(';');
        }
        tmpInput.value = url;
        document.body.appendChild(tmpInput);

        tmpInput.select();
        document.execCommand('Copy');
        alert('已成功复制到剪贴板');
      } else if (window.clipboardData) {
        window.clipboardData.setData('Text', url);
        alert('已成功复制到剪贴板');
      } else {
        window.prompt('请复制下面链接分享', url);
      }
      return;
    }

    let params = {
      type: type,
      sharetype: sharetype,
      title: title,
      content: content,
      url: url,
      thumb: thumb,
    };

    // 添加分享平台支持
    if (platform) {
      if (Object.prototype.toString.call(platform) === '[object String]') {
        params.platform = platform;
      } else if (platform.length > 0) {
        let sharePlatform = [];

        platform = platform || [];

        for (let i = 0; i < platform.length; i++) {
          sharePlatform.push(parseInt(platform[i], 10));
        }

        params.platform = JSON.stringify(sharePlatform);
      }
    }

    // 小呼吸/焦糖要多加一个字段，才能显示分享出去的标题
    if (process.env.project === 'xiaohuxi' || process.env.project === 'caramel') {
      params.sharetitle = sharetitle;
    }

    ApiBridge.callNative('jsBridgeClient', 'share', params);
    ApiBridge.callNative('jsBridgeClient', 'oxygen__share', params);
  };

  /**
   * 页面关注用户
   * @params { Number } id, 关注的用户id
   * @params {  } value, 不确定
   */
  kerkee.sendFollow = function (id, value) {
    ApiBridge.callNative('jsBridgeClient', 'sendFollow', {
      id: id,
      value: value,
    });
    ApiBridge.callNative('jsBridgeClient', 'oxygen__sendFollow', {
      id: id,
      value: value,
    });
  };

  /**
   * 跳转充值界面
   */
  kerkee.goCharge =
    kerkee.showRecharge =
    kerkee.charge =
      function () {
        if (IS_PC_CLIENT) {
          let pcurl = `${envConf.PC}#/wallet/recharge`;
          PCNativeBridge.createNewWebPage(pcurl, { width: 640, height: 530 });
          return;
        }
        if (process.env.project === 'xiaohuxi' || process.env.project === 'caramel') {
          ApiBridge.callNative('jsBridgeClient', 'showRecharge');
          return;
        }
        ApiBridge.callNative('jsBridgeClient', 'charge');
        ApiBridge.callNative('jsBridgeClient', 'oxygen__charge');
      };

  /**
   * 弹出自己的靓号仓库【不确定】
   * @params { Function }, callback 回调
   */
  kerkee.showPlayerIdLibrary = function (callback) {
    ApiBridge.callNative('jsBridgeClient', 'showPlayerIdLibrary', {}, callback);
    ApiBridge.callNative('jsBridgeClient', 'oxygen__showPlayerIdLibrary', {}, callback);
  };

  /**
   *  【不确定】
   */
  kerkee.getNumberOfActivities = function (name, value, callback) {
    ApiBridge.callNative(
      'jsBridgeClient',
      'getNumberOfActivities',
      {
        activityName: name,
        isSave: value,
      },
      callback
    );
    ApiBridge.callNative(
      'jsBridgeClient',
      'oxygen__getNumberOfActivities',
      {
        activityName: name,
        isSave: value,
      },
      callback
    );
  };

  /**
   * 获取用户在线等级【不确定】
   * @params { Function }, callback 回调
   */
  kerkee.getLevel = function (callback) {
    ApiBridge.callNative('jsBridgeClient', 'getLevel', {}, callback);
    ApiBridge.callNative('jsBridgeClient', 'oxygen__getLevel', {}, callback);
  };

  /**
   * 弹出名片,调用个人资料窗口
   * @params { Number }, pid 用户id
   */
  kerkee.getPlayerData = function (pid) {
    if (IS_PC_CLIENT) {
      PCNativeBridge.showVisitingCard(pid).catch((err) => {
        PCNativeBridge.showUserProfile(pid);
      });
      return;
    }

    ApiBridge.callNative('jsBridgeClient', 'getPlayerData', {
      pid: pid,
    });
    ApiBridge.callNative('jsBridgeClient', 'oxygen__getPlayerData', {
      pid: pid,
    });
  };

  // 打开页面
  kerkee.openPage = function (title, url) {
    ApiBridge.callNative('jsBridgeClient', 'openPage', {
      title: title,
      url: url,
    });
    ApiBridge.callNative('jsBridgeClient', 'oxygen__openPage', {
      title: title,
      url: url,
    });
  };

  // 客户端输出页面传过来的content
  // 当前只有小呼吸定义了这个方法
  kerkee.printLog = function (content) {
    ApiBridge.callNative('jsBridgeClient', 'printLog', {
      content: content,
    });
  };

  /**
   * 打开页面，跳转app路由【不确定】【焦糖IOS没实现】
   * @params { String }, internalUrl app路由地址
   */
  kerkee.jumpInternalRoute = function (internalUrl) {
    ApiBridge.callNative('jsBridgeClient', 'jumpInternalRoute', {
      internalUrl: internalUrl,
    });
  };

  /**
   *  【不确定】
   */
  kerkee.chatMessage = function (msg) {
    ApiBridge.callNative('jsBridgeClient', 'chatMessage', {
      msg: msg,
    });
  };

  /**
   * 开启webview console.log功能
   */
  kerkee.openJSLog = function () {
    _Configs.isOpenJSLog = true;
    global.console.log = ApiBridge.log;
  };

  /**
   * 关闭webview console.log功能
   */
  kerkee.closeJSLog = function () {
    _Configs.isOpenJSLog = false;
    global.console.log = _Configs.sysLog;
  };

  /**
   * 【不确定】
   */
  kerkee.commonApi = function (aString, callback) {
    ApiBridge.callNative(
      'jsBridgeClient',
      'commonApi',
      {
        info: aString,
      },
      callback
    );
  };

  /**
   * 【不确定】
   */
  kerkee.onSetImage = function (srcSuffix, desUri) {
    // console.log("--- kerkee onSetImage ---");
    var obj = document.querySelectorAll('img[src$="' + srcSuffix + '"]');
    for (var i = 0; i < obj.length; ++i) {
      obj[i].src = desUri;
    }
  };

  /**
   * 设置内嵌页面卡片展示高度
   * @params { Number }, height 高度
   * @params { width }, height 宽度
   */
  kerkee.cardHeight = function (height, width) {
    let params = {
      height: Number(height),
    };

    if (typeof width !== 'undefined') {
      params.width = width;
    }

    ApiBridge.callNative('jsBridgeClient', 'cardHeight', params);
  };

  /**
   * 打开外部浏览器(safari等)
   * @params { String } url, 需要打开的链接
   */
  kerkee.openBrowser = function (url) {
    if (IS_PC_CLIENT) {
      PCNativeBridge.openIExplorer(url);
      return;
    }

    let params = {
      url: url + '',
    };
    ApiBridge.callNative('jsBridgeClient', 'openBrowser', params);
  };

  /**
   * 跳转点单界面
   * @params { Number }, id 跳转路由id，PC为tab序号
   * @params { String }, type, scheme, m.mizhua.net等
   */
  kerkee.openBillShowPeopleWindow = function (id, type) {
    if (IS_PC_CLIENT) {
      id = typeof id !== 'undefined' || +id < 3 ? id : 0;
      PCNativeBridge.openBillShowPeopleWindow(id);
      return;
    }
    type = typeof type === 'undefined' ? 0 : type;

    let scheme = curScheme; // 统一为curScheme
    kerkee.jumpInternalRoute(`${scheme}?dyaction=anotherhome&classifyid=${id}`);
  };

  /**
   * 退出到登录页面
   * @params { Boolean } ispopout: true: 清除账号信息，弹出登陆页面, false: 就是清除账号信息，界面不发生改变
   * @params { Number } logoutType:0 无 1 注销
   */
  kerkee.logout = function (ispopout, type = 0) {
    if (IS_PC_CLIENT && !!ispopout) {
      if (type === 1) {
        PCNativeBridge.logoutRestart();
      } else {
        PCNativeBridge.restartApp();
      }
      return;
    }
    ApiBridge.callNative('jsBridgeClient', 'logoutButtonDidClick', {
      ispopout: !!ispopout,
      logoutType: type,
    });
  };

  /**
   * 显示或隐藏左上角返回按钮
   * @params { Boolean }, ishidden: true 隐藏，false 显示
   */
  kerkee.switchLeftBtn = function (ishidden) {
    ApiBridge.callNative('jsBridgeClient', 'leftButtonSwitchHidden', {
      ishidden: ishidden,
    });
  };

  /**
   * 拦截安卓物理返回键
   * @params { Boolean } isCanGoBack true：开启拦截 false：关闭拦截
   * @returns { Function } , 自定义window.hardwareBackPress会自动拦截
   */
  kerkee.setCanGoBack = function (isCanGoBack) {
    if (browser.versions.android) {
      ApiBridge.callNative('jsBridgeClient', 'setCanGoBack', {
        isCanGoBack: !!isCanGoBack,
      });
    }
  };
  /**
   * App内购
   * app提供:
   * int payType（微信=0， 支付宝=1）
     String accountId 账号
     String gold 金额
     int orderId 订单号（可选）
     h5提供:nativePayCallback
     参数：boolean isSuccess
          String errorMsg
   */
  kerkee.nativePay = function (data) {
    if (browser.versions.inApp) {
      ApiBridge.callNative('jsBridgeClient', 'nativePay', data);
    }
  };

  /**
   * 订阅推送
   * app提供:
   * int id 唯一订阅id,协议约定
     h5提供:subscribeCallback
     参数：String data
   */
  kerkee.subscribe = function (data) {
    const obj = {
      id: data.id,
      ids: data.ids || [],
      pcBrowserId: data.pcBrowserId || '',
    };

    if (IS_PC_CLIENT) {
      PCNativeBridge.subscribe(JSON.stringify(obj));
    } else {
      ApiBridge.callNative('jsBridgeClient', 'subscribe', obj);
    }
  };

  /**
   * App播放爵位开通动画
   * app提供:
   * int nobilityId
   */
  kerkee.notifyShowEffect = function (nobilityId) {
    if (IS_PC_CLIENT) {
      PCNativeBridge.notifyShowEffect(nobilityId);
      return;
    }
    if (browser.versions.inApp) {
      ApiBridge.callNative('jsBridgeClient', 'notifyShowEffect', nobilityId);
    }
  };

  /**
   * App跳转ios支付
   * app提供:
   * int nobilityId
   * int buyType
   * int benefitId
   */
  kerkee.mainpageNobility = function (data) {
    if (browser.versions.inApp) {
      ApiBridge.callNative('jsBridgeClient', 'mainpageNobility', data);
    }
  };

  /**
   * 窗口之间交互
   * app提供:
   * int pos: 弹窗位置(值为-1|0|1|2|3|4，分别对应全屏|bottom|top|left|right|mid(缺省为0)
   * int data 传输数据
   */
  kerkee.dynamicCall = function (data) {
    if (browser.versions.inApp) {
      ApiBridge.callNative('jsBridgeClient', 'dynamicCall', data);
    }
  };

  /**
   * 获取好友列表
   * @params { Number }, type：0-占位不用 1-所有分类 2-好友 3-关注 4-粉丝 5-屏蔽
   * @returns { JSON }  返回结果按照首字母排序
   * 例如： {
   *    A: [10086, 100034, 112298],
   *    C: [110256],
   *    W: [210056, 10086],
   *    X: [112356]
   * }
   */
  kerkee.getRelationshipList = function (type, callback) {
    if (IS_PC_CLIENT) return;

    ApiBridge.callNative(
      'jsBridgeClient',
      'getRelationshipList',
      {
        type: type,
      },
      callback
    );
    ApiBridge.callNative(
      'jsBridgeClient',
      'oxygen__getRelationshipList',
      {
        type: type,
      },
      callback
    );
  };

  /**
   * 根据关键字搜索好友
   * @params { Number，String }
   * type：0-占位不用 1-所有分类 2-好友 3-关注 4-粉丝 5-屏蔽
   * keyword: 关键字
   * @returns { JSON }  返回结果按照首字母排序
   * 例如： {
   *    A: [10086, 100034, 112298],
   *    C: [110256],
   *    W: [210056, 10086],
   *    X: [112356]
   * }
   */
  kerkee.searchRelationship = function (type, keyword, callback) {
    if (IS_PC_CLIENT) return;

    ApiBridge.callNative(
      'jsBridgeClient',
      'searchRelationship',
      {
        type: type,
        keyword: keyword,
      },
      callback
    );
    ApiBridge.callNative(
      'jsBridgeClient',
      'oxygen__searchRelationship',
      {
        type: type,
        keyword: keyword,
      },
      callback
    );
  };

  /**
   *  【焦糖】举报功能调用上传接口
   *  @return 回调 uploadReportImageCallback({"data": "图片id", "msg": "原因"});
   */
  kerkee.uploadReportImage = function () {
    ApiBridge.callNative('jsBridgeClient', 'uploadReportImage');
  };

  /**
   *  【焦糖】保存图片到本地接口(>=5.0.0)
   *  @param { Object } data { url: url }
   *  @return 回调 savePictureCallback({"data": "string|可选|保存的路径或原因", "code": "0成功,1失败"});
   */
  kerkee.savePicture = function (url) {
    ApiBridge.callNative('jsBridgeClient', 'savePicture', {
      url: url,
    });
  };

  /**
   *  【焦糖，已去掉】上报罗盘数据(>=5.0.0)
   *  @param { Object } dataJSON { dataJSON: dataJSON }
   */
  kerkee.reportCompass = function (dataJSON) {
    // console.log(dataJSON);
    ApiBridge.callNative('jsBridgeClient', 'reportCompass', {
      dataJSON: dataJSON,
    });
  };

  /**
   * 来自菜鸡罗盘上报数据
   * @param { string|object } jsonStr, json 或 json字符串
   */
  kerkee.onCompassStat = function (jsonStr) {
    if (Object.prototype.toString.call(jsonStr) === '[object Object]') {
      jsonStr = JSON.stringify(jsonStr);
    }
    ApiBridge.callNative('jsBridgeClient', 'onCompassStat', {
      json: jsonStr,
    });
  };

  /**
   * 调用APP的数据埋点
   * @param { string|object } jsonStr, json 或 json字符串
   */
  kerkee.onReportEvent = function (jsonStr) {
    console.log('kerkee.onReportEvent', jsonStr);
    if (Object.prototype.toString.call(jsonStr) === '[object Object]') {
      jsonStr = JSON.stringify(jsonStr);
    }
    ApiBridge.callNative('jsBridgeClient', 'onReportEvent', {
      json: jsonStr,
    });
  };

  /**
   * 更改页面标题（焦糖）
   * @params { String } title, 标题
   */
  kerkee.transmitTitle = function (title) {
    ApiBridge.callNative('jsBridgeClient', 'transmitTitle', {
      title,
    });
  };

  /**
   * 打开IM面板
   * @params { config }, internalUrl:  schema路由
   */
  kerkee.openOrderCard = function (config) {
    if (IS_PC_CLIENT) {
      PCNativeBridge.openIMMessageWindow(config).catch((err) => {
        PCNativeBridge.showUserProfile(config);
      });
      return;
    }
    ApiBridge.callNative('jsBridgeClient', 'jumpInternalRoute', config);
  };

  /**
   * h5日志打印
   * @param { string|object } jsonStr, json 或 json字符串
   */
  kerkee.printLog = function (jsonStr) {
    if (Object.prototype.toString.call(jsonStr) === '[object Object]') {
      jsonStr = JSON.stringify(jsonStr);
    }
    ApiBridge.callNative('jsBridgeClient', 'printLog', {
      content: jsonStr,
    });
  };

  /**
   * h5日志上传
   * @param { string|object } jsonStr, json 或 json字符串
   */
  kerkee.uploadLog = function (jsonStr) {
    if (Object.prototype.toString.call(jsonStr) === '[object Object]') {
      jsonStr = JSON.stringify(jsonStr);
    }
    ApiBridge.callNative('jsBridgeClient', 'uploadLog', {
      content: jsonStr,
    });
  };

  /**
   * 通知客户端当前窗口关闭前 要调用前端的方法fnWinCloseCallback。注意定义fnWinCloseCallback方法
   * 移动端调用时机： 页面加载完毕后 和 窗口关闭前
   * @param {  object } PreCondition: Boolean
   */
  kerkee.webSetClosePreCondition = function (data) {
    ApiBridge.callNative('jsBridgeClient', 'webSetClosePreCondition', data);
  };

  /**
   *  客户端自定截屏
   * @param {  object }
   */
  kerkee.webCaptureScreen = function (data, callback) {
    ApiBridge.callNative('jsBridgeClient', 'webCaptureScreen', data, callback);
  };

  /**
   *  客户端ping网络
   * @param {  object }
   */
  kerkee.ping = function (callback) {
    ApiBridge.callNative('jsBridgeClient', 'ping', {}, callback);
  };

  /**
   * webSaveFile: 保存图片到本地
   * @params {"fileTye": 1, "fileUrl":"", fileName: ""} filetype为文件类型，1表示存储图片（刷新相册
   * @return 完成触发回调webSaveFileCallback  {"result": true, "info":"",} 结果, info成功是路径,失败是原因
   */
  kerkee.webSaveFile = function (data = {}) {
    if (IS_PC_CLIENT) {
      var ele = document.createElement('a');
      ele.setAttribute('href', data.fileUrl);
      ele.setAttribute('download', 'share');
      ele.click();
      return;
    }
    ApiBridge.callNative('jsBridgeClient', 'webSaveFile', {
      fileTye: data.fileTye || 1,
      fileUrl: data.fileUrl || '',
      fileName: data.fileName || '',
    });
  };

  /*
   * var windowOpen = function (url) { ApiBridge.callNative("JavascriptAPIInterceptor", "windowOpen", { "url" : url }); };
   */
  global.ApiBridge = ApiBridge;
  global.kerkee = kerkee;
  // global.open = windowOpen;
  //global.XMLHttpRequest = _XMLHttpRequest;
  global.jsBridgeClient = kerkee;

  // 注册事件，绑定到全局方法
  kerkee.register = function (_window) {
    _window.ApiBridge = window.ApiBridge;
    _window.kerkee = window.kerkee;
    _window.console.log = window.console.log;
    _window.XMLHttpRequest = window.XMLHttpRequest;
    _window.open = window.open;
  };

  // 客户端配置 TODO
  ApiBridge.onBridgeInitComplete(function (aConfigs) {
    if (IS_PC_CLIENT) {
      return;
    }

    if (aConfigs) {
      /* if (aConfigs.hasOwnProperty('isOpenJSLog')) {
         _Configs.isOpenJSLog = aConfigs.isOpenJSLog;
       } */
      if (aConfigs.hasOwnProperty('isOpenNativeXHR')) {
        _Configs.isOpenNativeXHR = aConfigs.isOpenNativeXHR;
      }
    }
    /* if (_Configs.isOpenJSLog) {
       global.console.log = ApiBridge.log;
     } */
    ApiBridge.onNativeInitComplete(ApiBridge.onDeviceReady);
  });
})(window);
